import { injectIntl } from 'react-intl'
import { ReservationItemsView } from './ReservationItemsView'

const ReservationItemsContainer = injectIntl(ReservationItemsView)

export { ReservationItemsContainer }
